module.exports = __webpack_public_path__ + "static/media/device_add_sample.70940bae.csv";